export default "__VITE_ASSET__705c5ef7__"